import { setTrackCenterline } from '../utils/constants.js';

// Dispatch table for inbound WebSocket messages.
export class MessageHandler {
  constructor(gameState) {
    this.gameState = gameState;
    this.scene = null;
    this.handlers = new Map();
  }

  // Game.init wires the Scene in once it's been constructed, so the
  // race_start handler can call rebuildWorld() with the new track.
  setScene(scene) {
    this.scene = scene;
  }

  // Subscribe to active_games messages — used by Game.js to feed the
  // lobby's Live Games list.
  setActiveGamesHandler(fn) {
    this._onActiveGames = fn;
  }

  // Subscribe to leaderboard pushes (sent on connect + after every race
  // finish, only if LEADERBOARD_PATH is configured server-side).
  setLeaderboardHandler(fn) {
    this._onLeaderboard = fn;
  }

  handle(message) {
    const { type, payload } = message;
    const handler = this.handlers.get(type);
    if (handler) handler(payload);
    else console.warn('unhandled message:', type);
  }

  on(type, handler) {
    this.handlers.set(type, handler);
  }

  setupDefaultHandlers() {
    this.on('hello', (p) => {
      this.gameState.clientId = p.clientId;
      this.gameState.displayName = p.displayName;
      console.log('hello from server:', p.displayName, p.clientId);
    });

    this.on('race_start', (p) => {
      console.log('race start:', p);
      // Swap the track centerline + rebuild the world meshes BEFORE we let
      // startRace seed the local position from the new track. Otherwise the
      // racer would spawn against the old terrain for one frame.
      const newCenterline = p?.track?.ghostPath;
      if (newCenterline && newCenterline.length >= 2) {
        setTrackCenterline(newCenterline);
        this.scene?.rebuildWorld?.();
      }
      this.gameState.startRace(p);
    });

    this.on('race_update', (p) => {
      this.gameState.applyServerUpdate(p);
    });

    this.on('item_grant', (p) => {
      this.gameState.heldItem = p.itemType;
    });

    this.on('item_hit_applied', (p) => {
      this.gameState.applyHit(p);
    });

    this.on('race_over', (p) => {
      console.log('race over:', p);
      this.gameState.finishRace(p);
    });

    this.on('error', (p) => {
      console.error('server error:', p.message);
    });

    this.on('active_games', (p) => {
      // Game.js subscribes via setActiveGamesHandler.
      this._onActiveGames?.(p);
    });

    this.on('leaderboard', (p) => {
      this._onLeaderboard?.(p);
    });
  }
}
